<div class="register-container">
  <div class="wrapper">
    <!-- LEFT SIDE -->
    <section [class]="loginLeftCssClass" [innerHTML]="loginLeftBoxHtml">
    </section>

    <!-- RIGHT SIDE -->
    <section class="register-panel login-panel">
      <div class="register-card login-card">
        <div class="register-header login-header hide">
          <h2>Create Account</h2>
          <p>Fill in the details to register a new user</p>
        </div>

        <!-- Success Message -->
        <div *ngIf="successMessage" class="alert alert-success" role="alert">
          <mat-icon fontSet="material-symbols-rounded" class="alert-icon">check_circle</mat-icon>
          {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
          <mat-icon fontSet="material-symbols-rounded" class="alert-icon">error</mat-icon>
          <div class="alert-message">
            <div *ngFor="let line of errorMessage.split('\n')">{{ line }}</div>
          </div>
        </div>

        <form class="register-form login-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <!-- Username Field -->
          <div class="">
            <!--<label for="username" class="form-label">
    Username <span class="required">*</span>
  </label>-->
            <div class="input-group">
              <span class="input-icon">
                <mat-icon fontSet="material-symbols-rounded">person</mat-icon>
              </span>
              <input id="username"
                     type="text"
                     placeholder="Enter username"
                     formControlName="userName"
                     (change)="onUsernameChange($event.target.value)"
                     [class.is-invalid]="userName?.invalid && userName?.touched"
                     [class.is-valid]="userFound"
                     [disabled]="isCheckingUsername" />

            </div>
            <!-- Username checking spinner -->
            <div *ngIf="isCheckingUsername" class="spinner-small">
              <mat-spinner [diameter]="20" [strokeWidth]="2"></mat-spinner>
            </div>
            <!-- Username validation icons -->
            <div *ngIf="!isCheckingUsername && userFound && !userRegistered" class="validation-icon success small">
              <mat-icon fontSet="material-symbols-rounded">check_circle</mat-icon>
              User found. Please complete the registration.
            </div>
            <div *ngIf="!isCheckingUsername && !userFound && userRegistered" class="validation-icon success small">
              <mat-icon fontSet="material-symbols-rounded">check_circle</mat-icon>
              User registered successfully!
            </div>
            <div *ngIf="!isCheckingUsername && usernameNotFound" class="validation-icon error-strip small">
              <mat-icon fontSet="material-symbols-rounded">cancel</mat-icon>User not found
            </div>
            <div *ngIf="!isCheckingUsername && userFound && userRegistered" class="validation-icon warning-strip small">
              <mat-icon fontSet="material-symbols-rounded">warning</mat-icon>
              User already registered. Please login or use a different username.
            </div>
            <div *ngIf="userName?.invalid && userName?.touched" class="text-danger small hide">
              <div *ngIf="userName?.errors?.['required']">Username is required</div>
              <div *ngIf="userName?.errors?.['minlength']">Username must be at least 3 characters</div>
            </div>
            <div *ngIf="userFound" class="text-success small hide">
              <mat-icon fontSet="material-symbols-rounded">check_circle</mat-icon>
              User found. Please complete the registration.
            </div>
          </div>

          <!-- Email Field (Read-only after lookup) -->
          <div class="">
            <!--<label for="email" class="form-label">
              Email <span class="required">*</span>
            </label>-->
            <div class="input-group">
              <span class="input-icon">
                <mat-icon fontSet="material-symbols-rounded">mail</mat-icon>
              </span>
              <input id="email"
                     type="email"
                     placeholder="Email will be auto-populated"
                     formControlName="email"
                     [class.is-invalid]="email?.invalid && email?.touched"
                     [readonly]="userFound" />
            </div>
            <div *ngIf="email?.invalid && email?.touched" class="text-danger small hide">
              <div *ngIf="email?.errors?.['required']">Email is required</div>
              <div *ngIf="email?.errors?.['email']">Please enter a valid email address</div>
            </div>
          </div>

          <!-- Phone Number Field (Read-only after lookup) -->
          <div class="">
            <!--<label for="contact1" class="form-label">
              Phone Number <span class="required">*</span>
            </label>-->
            <div class="input-group">
              <span class="input-icon">
                <mat-icon fontSet="material-symbols-rounded">phone</mat-icon>
              </span>
              <input id="contact1"
                     type="tel"
                     placeholder="Phone will be auto-populated"
                     formControlName="contact1"
                     [class.is-invalid]="contact1?.invalid && contact1?.touched"
                     [readonly]="userFound" />
            </div>
            <div *ngIf="contact1?.invalid && contact1?.touched" class="text-danger small hide">
              <div *ngIf="contact1?.errors?.['required']">Phone number is required</div>
              <div *ngIf="contact1?.errors?.['pattern']">Please enter a valid phone number</div>
            </div>
          </div>

          <!-- User Roles Dropdown -->
          <div class="input-group">
            <!--<label for="userRoles" class="form-label">
              User Role <span class="required">*</span>
            </label>-->
            <mat-form-field appearance="outline" class="full-width w-100">
              <!--<mat-label>Select Role</mat-label>-->
              <span class="input-icon">
                <mat-icon fontSet="material-symbols-rounded">user_attributes</mat-icon>
              </span>
              <mat-select placeholder="Select Role"
                          id="userRoles"
                          formControlName="userRoles"
                          multiple
                          [compareWith]="compareRoles">
                <mat-option *ngFor="let role of userRoleList" [value]="role">
                  {{ role.RoleName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="userRoles?.hasError('rolesRequired')">
                At least one role must be selected
              </mat-error>
            </mat-form-field>
            <div *ngIf="userRoles?.invalid && userRoles?.touched" class="text-danger small hide">
              <div *ngIf="userRoles?.errors?.['rolesRequired']">
                <mat-icon fontSet="material-symbols-rounded" class="inline-icon">error</mat-icon>
                At least one role must be selected
              </div>
            </div>
          </div>

          <!-- Password Field -->
          <div class="">
            <!--<label for="password" class="form-label">
              Password <span class="required">*</span>
            </label>-->
            <div class="input-group">
              <span class="input-icon">
                <mat-icon fontSet="material-symbols-rounded">lock</mat-icon>
              </span>
              <input id="password"
                     [type]="showPassword ? 'text' : 'password'"
                     placeholder="Enter a strong password"
                     formControlName="password"
                     [class.is-invalid]="password?.invalid && password?.touched" />
              <button type="button"
                      class="eye-btn"
                      (click)="togglePasswordVisibility()"
                      tabindex="-1">
                <mat-icon fontSet="material-symbols-rounded">
                  {{ showPassword ? 'visibility' : 'visibility_off' }}
                </mat-icon>
              </button>
            </div>
            <div *ngIf="password?.invalid && password?.touched" class="text-danger small">
              <div *ngIf="password?.errors?.['required']">Password is required</div>
              <div *ngIf="password?.errors?.['minlength']" class="hide">
                Password must be at least 6 characters
              </div>
              <div *ngIf="password?.errors?.['passwordStrength']">
                {{ getErrorMessage('password') }}
              </div>
            </div>
            <div class="password-hint small hide">
              <mat-icon fontSet="material-symbols-rounded" class="inline-icon">info</mat-icon>
              Password must contain at least one uppercase letter and one digit
            </div>
          </div>

          <!-- Submit Button -->
          <button class="login-btn"
                  type="submit"
                  [disabled]="registerForm.invalid || isSubmitting || !userFound || userRegistered" >
            <span *ngIf="!isSubmitting">Register User</span>
            <span *ngIf="isSubmitting">
              <i class="fas fa-spinner fa-spin"></i> Registering...
            </span>
          </button>

          <!-- Back to Login -->
          <div class="back-link">
            <a routerLink="/login">
              <mat-icon fontSet="material-symbols-rounded">arrow_back</mat-icon>
              Back to Login
            </a>
          </div>
        </form>
      </div>
    </section>
  </div>
</div>
